import { POST_ADOPT_PROJECT_CATEGORY } from '@/api/reportApi'

/**
 * 项目类目 AI 推荐的「采用」埋点。
 *
 * 点击采用只登记，等保存/提交成功后才回传：中途改成别的类目、或者压根没提交，
 * 都不该算作使用了推荐类目。登记落在 sessionStorage，避免热更新、页面刷新
 * 丢掉待上报记录。
 */
interface PendingAdoption {
  platformCode: string
  fieldKey: string
  requestId: string
  categoryCode: string
}

const STORAGE_KEY = 'projectCategoryAdoptions'

const adoptionKey = (platformCode: string, fieldKey: string) =>
  `${platformCode}_${fieldKey}`

const readAll = (): Record<string, PendingAdoption> => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

const writeAll = (adoptions: Record<string, PendingAdoption>) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(adoptions))
  } catch {
    // 存不下就放弃埋点，不影响提报
  }
}

export const rememberProjectCategoryAdoption = (adoption: PendingAdoption) => {
  const adoptions = readAll()
  adoptions[adoptionKey(adoption.platformCode, adoption.fieldKey)] = adoption
  writeAll(adoptions)
}

/** 改成人工选择的类目或清空时撤销登记，这次就不算用了推荐。 */
export const forgetProjectCategoryAdoption = (
  platformCode: string,
  fieldKey: string,
) => {
  const adoptions = readAll()
  delete adoptions[adoptionKey(platformCode, fieldKey)]
  writeAll(adoptions)
}

/**
 * 保存/提交成功后调用：把本次登记的采用记录发给服务端。
 * 埋点失败静默丢弃，不影响提报结果。
 */
export const reportProjectCategoryAdoptions = async () => {
  const adoptions = Object.values(readAll())
  if (!adoptions.length) return
  writeAll({})
  await Promise.all(
    adoptions.map(async (adoption) => {
      try {
        await POST_ADOPT_PROJECT_CATEGORY({
          platformCode: adoption.platformCode,
          requestId: adoption.requestId,
          categoryCode: adoption.categoryCode,
        })
      } catch (error) {
        console.warn('[项目类目AI推荐] 采用埋点上报失败', error)
      }
    }),
  )
}
import { POST_ADOPT_PROJECT_CATEGORY } from '@/api/reportApi'

/**
 * 项目类目 AI 推荐的「采用」埋点。
 *
 * 点击采用只登记，等保存/提交成功后才回传：中途改成别的类目、或者压根没提交，
 * 都不该算作使用了推荐类目。登记落在 sessionStorage，避免热更新、页面刷新
 * 丢掉待上报记录。
 */
interface PendingAdoption {
  platformCode: string
  fieldKey: string
  requestId: string
  categoryCode: string
}

const STORAGE_KEY = 'projectCategoryAdoptions'

const adoptionKey = (platformCode: string, fieldKey: string) =>
  `${platformCode}_${fieldKey}`

const readAll = (): Record<string, PendingAdoption> => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

const writeAll = (adoptions: Record<string, PendingAdoption>) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(adoptions))
  } catch {
    // 存不下就放弃埋点，不影响提报
  }
}

export const rememberProjectCategoryAdoption = (adoption: PendingAdoption) => {
  const adoptions = readAll()
  adoptions[adoptionKey(adoption.platformCode, adoption.fieldKey)] = adoption
  writeAll(adoptions)
}

/** 改成人工选择的类目或清空时撤销登记，这次就不算用了推荐。 */
export const forgetProjectCategoryAdoption = (
  platformCode: string,
  fieldKey: string,
) => {
  const adoptions = readAll()
  delete adoptions[adoptionKey(platformCode, fieldKey)]
  writeAll(adoptions)
}

/**
 * 保存/提交成功后调用：把本次登记的采用记录发给服务端。
 * 埋点失败静默丢弃，不影响提报结果。
 */
export const reportProjectCategoryAdoptions = async () => {
  const adoptions = Object.values(readAll())
  if (!adoptions.length) return
  writeAll({})
  await Promise.all(
    adoptions.map(async (adoption) => {
      try {
        await POST_ADOPT_PROJECT_CATEGORY({
          platformCode: adoption.platformCode,
          requestId: adoption.requestId,
          categoryCode: adoption.categoryCode,
        })
      } catch (error) {
        console.warn('[项目类目AI推荐] 采用埋点上报失败', error)
      }
    }),
  )
}
